













import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { Rule as RuleType, RuleStatus } from '@/modules/seo/types'

/**
 * Muestra la información de un regla de análisis SEO
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class Rule extends Vue {

    /**
     * Regla mostrada
     */
    @Prop({type: Object, default: () => new RuleType() })
    public value: RuleType

    private statusMap = {
        [RuleStatus.Pass]: { color: 'green', icon: 'check_circle'},
        [RuleStatus.Warning]: { color: 'orange', icon: 'warning'},
        [RuleStatus.Fail]: { color: 'red', icon: 'error'},
    }

    public get color (): string {
        return this.statusMap[this.value.status].color || 'green'
    }

    public get icon (): string {
        return this.statusMap[this.value.status].icon || 'check_circle'
    }
}
